import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { Router, RouterLink } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthServiceService } from '../../../services/authService/auth-service.service';

@Component({
  selector: 'app-courses',
  imports: [HeroComponent],
  templateUrl: './courses.component.html',
  styleUrl: './courses.component.css'
})
export class CoursesComponent {
  isLoggedIn=false;

  constructor(private router:Router,
        private authService:AuthServiceService,
    
  ){}

  ngOnInit(){
    this.isUserLoggedIn();
  }
    isUserLoggedIn(){
    this.authService.isUserLoggedIn().subscribe({
      next:res=>{ this.isLoggedIn=res},
    })
  }
  navigateToCourseApplyComponent(level: string) {
    if (this.isLoggedIn) {
      this.router.navigateByUrl("/CourseApply/" + level);
    } else {
     Swal.fire({
        icon: 'warning',
        title: 'Not logged in',
        text: 'You need to log in first to apply for this course.',
        confirmButtonText: 'OK'
      });
    }
}
}
